function closestElement(node) {
  // If self element is an element node then return it
  if (node.nodeType === Node.ELEMENT_NODE) {
    return node;
  }
  if (!node.parentElement) {
    return null;
  }
  if (node.parentElement.nodeType === Node.ELEMENT_NODE) {
    return node.parentElement;
  }
  return closestElement(node.parentElement);
}

export { closestElement };
